import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center gap-2.5" };
const _hoisted_2 = { class: "size-11 shrink-0 flex items-center justify-center overflow-hidden rounded-full border border-(--border-border-base-soft) bg-(--background-background-selected)" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
    key: 1,
    class: "ri-user-line text-xl text-(--text-text-body-subtle)"
};
const _hoisted_5 = { class: "flex flex-col min-w-0" };
const _hoisted_6 = { class: "font-(family-name:--family-heading) text-(length:--size-xl) font-semibold leading-(--line-height-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_7 = {
    key: 0,
    class: "inline-flex mt-0.5"
};
const _hoisted_8 = { class: "px-1 py-0.5 rounded text-xs font-medium text-(--text-text-black-default) bg-(--colors-error-100)" };
const _hoisted_9 = {
    key: 0,
    class: "flex justify-center items-center py-12"
};
const _hoisted_10 = {
    key: 1,
    class: "flex flex-col items-center gap-4 py-12 text-center"
};
const _hoisted_11 = { class: "text-sm text-(--text-text-black-default)" };
const _hoisted_12 = {
    key: 2,
    class: "flex flex-col gap-4"
};
const _hoisted_13 = { class: "flex flex-col gap-1" };
const _hoisted_14 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_15 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_16 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_17 = {
    key: 0,
    class: "flex flex-col gap-1"
};
const _hoisted_18 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_19 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_20 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_21 = {
    key: 1,
    class: "flex flex-col gap-1"
};
const _hoisted_22 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_23 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_24 = {
    key: 2,
    class: "flex flex-col gap-1"
};
const _hoisted_25 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_26 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_27 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_28 = {
    key: 3,
    class: "flex flex-col gap-1"
};
const _hoisted_29 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_30 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_31 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_32 = { class: "flex flex-col gap-1" };
const _hoisted_33 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_34 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_35 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Button, Drawer, PhoneDisplay } from '@eudonet/opal';
import { useProfileStore } from '@/modules/settings/public';
import { formatDate } from '@/shared/utils/date-formatting';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactPreviewDrawer',
    props: {
        modelValue: { type: Boolean },
        contact: {},
        loading: { type: Boolean },
        error: {}
    },
    emits: ["update:modelValue", "go-to", "retry"],
    setup(__props) {
        const props = __props;
        const { locale } = useI18n();
        const profileStore = useProfileStore();
        const fullName = computed(() => props.contact ? `${props.contact.firstName} ${props.contact.lastName}` : '');
        const addressText = computed(() => {
            const a = props.contact?.address;
            if (!a)
                return '';
            return [a.addressLine, a.postalCode, a.city, a.country].filter(Boolean).join(', ');
        });
        const formattedCreatedAt = computed(() => props.contact
            ? formatDate(props.contact.createdAt, locale.value, profileStore.profile?.dateFormat)
            : '');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Drawer), {
                "model-value": __props.modelValue,
                position: "right",
                size: "md",
                "show-close-button": true,
                "close-on-escape": true,
                dismissable: true,
                "backdrop-class": "!z-[55]",
                "panel-class": "!z-[60]",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('update:modelValue', $event)))
            }, _createSlots({
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "primary",
                        "full-width": "",
                        label: _ctx.$t('contact.create.preview.viewRecord'),
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('go-to')))
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1 /* CACHED */)
                            ]))]))
                        : (__props.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-error-warning-line text-3xl text-(--colors-icon-error)" }, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('contact.create.preview.error')), 1 /* TEXT */),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm font-medium text-(--text-text-link) hover:text-(--text-text-hover) transition-colors",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('retry')))
                                }, _toDisplayString(_ctx.$t('contact.create.preview.retry')), 1 /* TEXT */)
                            ]))
                            : (__props.contact)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('contact.create.fields.contactType')), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(`contact.create.contactType.${__props.contact.type === 'Professional' ? 'professional' : 'individual'}`)), 1 /* TEXT */)
                                        ])
                                    ]),
                                    (__props.contact.email)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('contact.create.preview.email')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_19, [
                                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-mail-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_20, _toDisplayString(__props.contact.email), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.contact.mainPhone)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('contact.create.preview.phone')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_23, [
                                                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-phone-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createVNode(_unref(PhoneDisplay), {
                                                    value: __props.contact.mainPhone,
                                                    link: false,
                                                    class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                                                }, null, 8 /* PROPS */, ["value"])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.contact.organisationLabel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('contact.create.preview.organisation')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_26, [
                                                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-building-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(__props.contact.organisationLabel), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (addressText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('contact.create.preview.address')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_30, [
                                                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-map-pin-2-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_31, _toDisplayString(addressText.value), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('contact.create.preview.createdAt')), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("span", _hoisted_35, _toDisplayString(formattedCreatedAt.value), 1 /* TEXT */)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (__props.contact)
                    ? {
                        name: "header",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (__props.contact.avatarUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: __props.contact.avatarUrl,
                                            alt: fullName.value,
                                            class: "size-full object-cover rounded-full"
                                        }, null, 8 /* PROPS */, _hoisted_3))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_4))
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(fullName.value), 1 /* TEXT */),
                                    (__props.contact.category)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`contact.create.fields.category.options.${__props.contact.category.toLowerCase()}`)), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value"]));
        };
    }
});
